import "./GroupNode.css";

import { Typography } from "@saviynt/design-system";
import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";

type GroupNodeProps = Node<{
  label: string;
  riskCount: number;
}>;

export default function GroupNode({ data }: NodeProps<GroupNodeProps>) {
  const { label, riskCount } = data;

  return (
    <div className="Nhi-AccessMap-Group-Node">
      <Handle type="target" position={Position.Left} />
      <Typography
        className="label"
        kind="body3"
        desktop="body3-d"
        mobile="body3-d"
      >
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        {label} ({riskCount})
      </Typography>
      <Handle type="source" position={Position.Right} />
    </div>
  );
}
